import {
  Card,
  CardBody,
  CardHeader,
  Collapse,
  Button,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import FeatherIcon from "feather-icons-react";

const MetaFields = ({ values, openGroups, toggleGroup, isPreviewOnly = false }) => {
  // Remove Formik dependencies since they're not needed in preview mode
  const renderAccountsSection = () => (
    <Row>
      {["heat", "water", "electricity"].map((key) => (
        <Col md={4} key={key}>
          <FormGroup>
            <Label for={`meta.accounts.${key}`}>
              {key.charAt(0).toUpperCase() + key.slice(1)} Provider/Account #
            </Label>
            <Input
              id={`meta.accounts.${key}`}
              type="text"
              value={values?.meta?.accounts?.[key] || "N/A"}
              disabled={true}
              readOnly={true}
            />
          </FormGroup>
        </Col>
      ))}
    </Row>
  );

  const renderSlotArray = (sectionName, displayName) => (
    <div className="mb-3">
      {values?.meta?.[sectionName]?.length > 0 ? (
        values.meta[sectionName].map((item, index) => (
          <Row key={index} className="mb-2">
            <Col md={6}>
              <FormGroup>
                <Label for={`meta.${sectionName}[${index}].type`}>{displayName} Type</Label>
                <Input
                  id={`meta.${sectionName}[${index}].type`}
                  type="text"
                  value={item.type || "N/A"}
                  disabled={true}
                  readOnly={true}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for={`meta.${sectionName}[${index}].stall_no`}>
                  {sectionName === "fobs" ? "FOB No." : "Stall Number"}
                </Label>
                <Input
                  id={`meta.${sectionName}[${index}].stall_no`}
                  type="text"
                  value={item.stall_no || "N/A"}
                  disabled={true}
                  readOnly={true}
                />
              </FormGroup>
            </Col>
          </Row>
        ))
      ) : (
        <div className="text-center mb-4">
          <p>No {displayName.toLowerCase()} slots assigned.</p>
        </div>
      )}
    </div>
  );

  const renderFobArray = () => (
    <div className="mb-3">
      {values?.meta?.fobs?.length > 0 ? (
        values.meta.fobs.map((fob, index) => (
          <Row key={index} className="mb-2">
            <Col md={4}>
              <FormGroup>
                <Label for={`meta.fobs[${index}].stall_no`}>FOB No.</Label>
                <Input
                  id={`meta.fobs[${index}].stall_no`}
                  type="text"
                  value={fob.stall_no || "N/A"}
                  disabled={true}
                  readOnly={true}
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for={`meta.fobs[${index}].type`}>Type</Label>
                <Input
                  id={`meta.fobs[${index}].type`}
                  type="text"
                  value={fob.type || "N/A"}
                  disabled={true}
                  readOnly={true}
                />
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label for={`meta.fobs[${index}].name`}>Name</Label>
                <Input
                  id={`meta.fobs[${index}].name`}
                  type="text"
                  value={fob.name || "N/A"}
                  disabled={true}
                  readOnly={true}
                />
              </FormGroup>
            </Col>
          </Row>
        ))
      ) : (
        <div className="text-center mb-4">
          <p>No FOBs assigned.</p>
        </div>
      )}
    </div>
  );

  const renderKeysSection = () => (
    <div className="mb-3">
      {values?.meta?.keys?.length > 0 ? (
        values.meta.keys.map((key, index) => (
          <Row key={index} className="mb-2">
            <Col md={3}>
              <FormGroup>
                <Label for={`meta.keys[${index}].main_entry`}>Main Entry Door Key</Label>
                <Input
                  id={`meta.keys[${index}].main_entry`}
                  type="text"
                  value={key.main_entry || "N/A"}
                  disabled={true}
                  readOnly={true}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label for={`meta.keys[${index}].suite`}>Suite Key</Label>
                <Input
                  id={`meta.keys[${index}].suite`}
                  type="text"
                  value={key.suite || "N/A"}
                  disabled={true}
                  readOnly={true}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label for={`meta.keys[${index}].mailbox`}>Mail Box Key</Label>
                <Input
                  id={`meta.keys[${index}].mailbox`}
                  type="text"
                  value={key.mailbox || "N/A"}
                  disabled={true}
                  readOnly={true}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label for={`meta.keys[${index}].storage`}>Storage Key</Label>
                <Input
                  id={`meta.keys[${index}].storage`}
                  type="text"
                  value={key.storage || "N/A"}
                  disabled={true}
                  readOnly={true}
                />
              </FormGroup>
            </Col>
          </Row>
        ))
      ) : (
        <div className="text-center mb-4">
          <p>No keys assigned.</p>
        </div>
      )}
    </div>
  );

  const renderOccupantsSection = () => (
    <div className="mb-3">
      {values?.meta?.occupants?.length > 0 ? (
        values.meta.occupants.map((occupant, index) => (
          <Row key={index} className="mb-3">
            <Col md={4}>
              <FormGroup>
                <Label for={`meta.occupants[${index}].name`}>Name</Label>
                <Input
                  id={`meta.occupants[${index}].name`}
                  type="text"
                  value={occupant.name || "N/A"}
                  disabled={true}
                  readOnly={true}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label for={`meta.occupants[${index}].phone`}>Phone</Label>
                <Input
                  id={`meta.occupants[${index}].phone`}
                  type="text"
                  value={occupant.phone || "N/A"}
                  disabled={true}
                  readOnly={true}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label for={`meta.occupants[${index}].email`}>Email</Label>
                <Input
                  id={`meta.occupants[${index}].email`}
                  type="email"
                  value={occupant.email || "N/A"}
                  disabled={true}
                  readOnly={true}
                />
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label for={`meta.occupants[${index}].age`}>Age</Label>
                <Input
                  id={`meta.occupants[${index}].age`}
                  type="number"
                  value={occupant.age || ""}
                  disabled={true}
                  readOnly={true}
                />
              </FormGroup>
            </Col>
          </Row>
        ))
      ) : (
        <div className="text-center mb-4">
          <p>No occupants assigned.</p>
        </div>
      )}
    </div>
  );

  // Read-only mirror of the edit form's ContactRepeater. `columns` is
  // [key, label, md]; an empty list reads "None entered".
  const renderContactList = (key, title, columns) => {
    const rows = Array.isArray(values?.meta?.[key]) ? values.meta[key] : [];
    return (
      <div className="mb-3">
        <Label className="fw-bold">{title}</Label>
        {rows.length === 0 ? (
          <div className="text-muted small mb-2">None entered</div>
        ) : (
          rows.map((row, index) => (
            <Row key={index} className="mb-2">
              {columns.map(([col, label, md]) => (
                <Col md={md} key={col}>
                  <FormGroup>
                    <Label for={`meta.${key}[${index}].${col}`}>{label}</Label>
                    <Input id={`meta.${key}[${index}].${col}`} type="text" value={row?.[col] || "N/A"} disabled={true} readOnly={true} />
                  </FormGroup>
                </Col>
              ))}
            </Row>
          ))
        )}
      </div>
    );
  };

  return (
    <>
      <Card className="mb-3">
        <CardHeader className="py-3 text-center">
          <Button
            color="primary"
            outline
            className="fw-bold px-4 py-2 rounded-pill"
            onClick={() => toggleGroup("meta")}
          >
            <FeatherIcon icon="zap" className="me-2" size={16} />
            Utility Information
          </Button>
        </CardHeader>
        <Collapse isOpen={openGroups["meta"]}>
          <CardBody>{renderAccountsSection()}</CardBody>
        </Collapse>
      </Card>
      <Card className="mb-3">
        <CardHeader className="py-3 text-center">
          <Button
            color="primary"
            outline
            className="fw-bold px-4 py-2 rounded-pill"
            onClick={() => toggleGroup("general")}
          >
            <FeatherIcon icon="home" className="me-2" size={16} />
            General Information
          </Button>
        </CardHeader>
        <Collapse isOpen={openGroups["general"]}>
          <CardBody>
            <Row>
              <Col md={6}>{renderSlotArray("parking", "Parking")}</Col>
              <Col md={6}>{renderSlotArray("storage", "Storage")}</Col>
            </Row>
            <Row>
              <Col md={6}>{renderOccupantsSection()}</Col>
              <Col md={6}>{renderFobArray()}</Col>
            </Row>
            <Row>
              <Col md={12}>
                {renderContactList("lease_holders", "Lease Holders", [["name", "Lease Holder Name", 4], ["email", "Email", 4], ["phone", "Contact", 4]])}
              </Col>
              <Col md={12}>
                {renderContactList("emergency_contacts", "Emergency Contacts", [["name", "Emergency Contact Name", 3], ["email", "Email", 3], ["phone", "Contact", 3], ["relation", "Relation", 3]])}
              </Col>
            </Row>
            <Row>{renderKeysSection()}</Row>
          </CardBody>
        </Collapse>
      </Card>
    </>
  );
};

export { MetaFields };